import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getTemplateById } from '../../permit-template/api/permit-template-api'
import type { TemplateFormData } from '../../permit-template/types/permit-template-types'

export const selectedChecklistQueryOptions = (templateVersionId: string) => ({
  queryKey: ['template-details', templateVersionId] as const,
  queryFn: () => getTemplateById(templateVersionId),
  enabled: Boolean(templateVersionId),
})

export const useSelectedChecklist = (selectedChecklistId: string) => {
  const { data: fetchedChecklist, isLoading } = useQuery(
    selectedChecklistQueryOptions(selectedChecklistId),
  )

  const [localOverride, setLocalOverride] = useState<TemplateFormData | null>(
    null,
  )

  useEffect(() => {
    setLocalOverride(null)
  }, [selectedChecklistId])

  const selectedChecklist = localOverride ?? fetchedChecklist ?? null

  return {
    selectedChecklist,
    originalChecklist: fetchedChecklist ?? null,
    setSelectedChecklist: setLocalOverride,
    isLoading,
  }
}
